/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';

type State = {
	[key: `${string}IsLoading`]: boolean;
};

export function withLoadingFeature(initialState: State) {
	return signalStoreFeature(
		withState(initialState),
		withComputed((state) => ({
			someRequestIsLoading: computed(() =>
				Object.entries(state)
					.filter(([key]) => key.includes('IsLoading'))
					.some(([, value]) => value()),
			),
		})),
		withMethods((store) => ({
			changeLoadingState(requestName: string, value: boolean) {
				patchState(store, (state) => ({
					...state,
					[`${requestName}IsLoading`]: value,
				}));
			},
		})),
	);
}
